import TeacherOccupations from '~/config/Constants/TeacherOccupations';

export default {
  IMPORT_FROM_OTHERS_FORM_URL: 'https://docs.google.com/forms/d/e/1FAIpQLSeX1jf20lfRqgA5i7UquTGrxJKTQ_Fv3VcLHpgiYE8Qloa_Yw/viewform',
  FeatureFlags: {
    AI_PAYWALL_BANNER: 'ai-paywall-banner',
    FFS_SCHOOL_PAGE: 'ffs-school-page',
    FFS_TEACHERS_COUNT: 'ffs-teachers-count',
    MC_LL: 'mc_library_limit',
    ENABLE_AI_PAYWALLING_BANNERS: 'enable-ai-paywalling-banners',
    ENABLE_NATIVE_FORM_FC: 'enable-native-form-fc',
    FFS_ADMIN_BANNER: 'ffs-admin-banner',
    PRICING_PAGE_TYPE_FORM_FC: 'pricing-page-typeform-fc',
    PRICING_PAGE_TYPE_FORM_MC: 'pricing-page-typeform-mc',
  },
};

export enum FFSUpsellType {
  DEFAULT = 'none',
  AI = 'ai',
  PREMIUM_QT = 'premium_qt',
  PREMIUM_CONTENT = 'premium_content',
};

export const FOCUS_COUNTRIES = ['AU', 'GB', 'CA'];

export const FFS_OCCUPATIONS = [...TeacherOccupations, 'school_admin', 'district_admin', 'administrator'];
export enum RESOURCE_TYPES {
  WORKSHEET = 'worksheet',
  LESSON = 'lesson',
  QUIZ = 'quiz',
  COLLECTION = 'collection',
  PROFILE = 'profile',
};

export enum FCImportBannerSource {
  WORKSHEET = 'fc-import-worksheet',
  GLOBE = 'fc-import-globe',
  FORM = 'fc-import-form',
};

export const GROWTH_EMAIL = 'growth_support@quizizz.com';
